import { c as _c } from "react/compiler-runtime";
import { FaUser } from "react-icons/fa";
import Image from "next/image";
import { Button, Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui";
import { formatStaffName } from "@/lib/format-data";
import { PublicProviderSummary } from "@/types/provider";
interface ProviderDetailsModalProps {
  provider: PublicProviderSummary | null;
  isOpen: boolean;
  onClose: () => void;
  onSelect: () => void;
}
export const ProviderDetailsModal = t0 => {
  const $ = _c(37);
  const {
    provider,
    isOpen,
    onClose,
    onSelect
  } = t0;
  if (!provider) {
    return null;
  }
  let t1;
  if ($[0] !== provider) {
    t1 = formatStaffName(provider);
    $[0] = provider;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const providerFullName = t1;
  const imageAlt = providerFullName;
  let t2;
  if ($[2] !== imageAlt || $[3] !== provider.profileImage) {
    t2 = provider.profileImage ? <Image src={provider.profileImage} alt={imageAlt} width={48} height={48} className="h-12 w-12 shrink-0 rounded-lg object-cover md:hidden" /> : <FaUser className="h-12 w-12 shrink-0 text-primary" />;
    $[2] = imageAlt;
    $[3] = provider.profileImage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== providerFullName) {
    t3 = <div className="min-w-0"><h2 className="text-h2">{providerFullName}</h2></div>;
    $[5] = providerFullName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <DialogHeader className="pb-1"><DialogTitle className="flex items-center gap-3">{t2}{t3}</DialogTitle></DialogHeader>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== imageAlt || $[11] !== provider.profileImage) {
    t5 = provider.profileImage && <Image src={provider.profileImage} alt={imageAlt} width={612} height={612} className="rounded-lg object-cover" />;
    $[10] = imageAlt;
    $[11] = provider.profileImage;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <div className="hidden md:block md:basis-1/3">{t5}</div>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== provider.bio) {
    t7 = provider.bio && <div><h3 className="mb-2 font-medium text-foreground">About</h3><p className="whitespace-pre-wrap leading-relaxed text-foreground-secondary">{provider.bio}</p></div>;
    $[15] = provider.bio;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <div className="space-y-4 md:basis-2/3">{t7}</div>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <DialogBody className="flex gap-4 pb-1">{t6}{t8}</DialogBody>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onClose) {
    t10 = <Button variant="secondary" onClick={onClose} className="flex-1 basis-1/3">Got it</Button>;
    $[22] = onClose;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== onSelect) {
    t11 = <Button onClick={onSelect} className="flex-1 basis-2/3" variant="primary">Select Provider</Button>;
    $[24] = onSelect;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <DialogFooter className="flex-row justify-end gap-2 pt-4">{t10}{t11}</DialogFooter>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t4 || $[31] !== t9) {
    t13 = <DialogContent className="max-w-[90vw] md:max-w-3xl">{t4}{t9}{t12}</DialogContent>;
    $[29] = t12;
    $[30] = t4;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== isOpen || $[34] !== onClose || $[35] !== t13) {
    t14 = <Dialog open={isOpen} onOpenChange={onClose}>{t13}</Dialog>;
    $[33] = isOpen;
    $[34] = onClose;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};